import { useState, useEffect, useRef } from "react";
import "./App.css";

function App() {
  const [showProposal, setShowProposal] = useState(false);
  const [showIntro, setShowIntro] = useState(true);
  const [introClosing, setIntroClosing] = useState(false);
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const [contentFading, setContentFading] = useState(false);
  const [phase, setPhase] = useState(null); // fase actual, null hasta que arranca
  const [displayedText, setDisplayedText] = useState("");
  const [typing, setTyping] = useState(false); // control de animación
  const audioRef = useRef(null);
  const typingAudioRef = useRef(null);

  const CORRECT_PASSWORD = "20092006pochacco";

  const phases = [
    { text: "Hola ❤", img: null },
    { text: "Hay algo que quería decirte hace un tiempo", img: "/escondido.gif" },
    { text: "Así que he hecho esto para decírtelo", img: "/pochacco_durmiendo.gif" },
    { text: "Estoy muy agradecido de tenerte", img: "/trampolin.gif" },
    { text: "Y también muy feliz de poder mejorar tus días, aunque sea solo un poco", img: "/trampolin.gif" },
    { text: "Quiero que nos sigamos acompañando el uno al otro", img: null },
    { text: "Así que...", img: null },
    { text: "...", img: null },
    { text: "¿Quieres ser mi novia?", img: "/besito.png" }
  ];

  useEffect(() => {
  if (!audioRef.current) return;
  // Antepenúltima fase → índice 6
  if (phase === 6) {
    audioRef.current.volume = 0.1;
  }
  // Penúltima fase → índice 7
  if (phase === 7) {
    audioRef.current.pause();
    audioRef.current.currentTime = 0;
  }
}, [phase]);


  // Bloquear scroll durante intro
  useEffect(() => {
    document.body.style.overflow = showIntro || phase === null ? "hidden" : "auto";
  }, [showIntro, phase]);

  // Máquina de escribir segura
  useEffect(() => {
    if (phase === null) return; // no hay fase
    if (!phases[phase] || !phases[phase].text) return;

    // fase 0 es estática, no animar
    if (phase === 0) {
      setDisplayedText(phases[phase].text);
      setTyping(false);
      return;
    }

    setDisplayedText(""); // limpiar antes de empezar
    setTyping(true);

    const text = phases[phase].text;
    let i = 0;

    const typeNextChar = () => {
      if (i < text.length) {
        const nextChar = text.charAt(i); // seguro, nunca undefined
        setDisplayedText((prev) => prev + nextChar);
        i++;

        // reproducir el audio mientras se escribe
        if (typingAudioRef.current && typingAudioRef.current.paused) {
          typingAudioRef.current.volume = 0.2;
          typingAudioRef.current.play();
        }

        setTimeout(typeNextChar, 40);
      } else {
        // texto completo → parar audio
        if (typingAudioRef.current) {
          typingAudioRef.current.pause();
          typingAudioRef.current.currentTime = 0;
        }
        setTyping(false); // animación terminada
      }
    };

    typeNextChar();

    // Cleanup por si se desmonta
    return () => setTyping(false);

  }, [phase]);

  // Intro Pochacco
  const handleIntroClick = () => {
    if (audioRef.current) {
      audioRef.current.volume = 0.2;
      audioRef.current.play();
    }
    setIntroClosing(true);
    setTimeout(() => {
      setShowIntro(false);
      setPhase(0); // primer texto estático "Hola"
    }, 900);
  };

  // Avanzar fases al pulsar
  const handlePhaseClick = () => {
    if (phase === 0) {
      // pasar a fase 1 con animación
      setPhase(1);
      return;
    }

    if (typing) return; // bloquear click mientras se escribe

    if (phase + 1 < phases.length) {
      setPhase(phase + 1);
    } else {
      setShowProposal(true); // última fase → propuesta
    }
  };

  return (
    <>
      <audio ref={audioRef} src="/bg-music.mp3" loop />
      <audio ref={typingAudioRef} src="/hablando.mp3" loop />


      {/* Pantalla de contraseña */}
      {!isUnlocked && (
        <div className="lock-screen">
          <div className={`lock-box ${contentFading ? "content-fade-out" : ""}`}>
            <p>Introduce la contraseña</p>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className={error ? "shake" : ""}
              autoFocus
            />
            <button
              onClick={() => {
                if (password === CORRECT_PASSWORD) {
                  setContentFading(true);
                  setTimeout(() => setIsUnlocked(true), 500);
                } else {
                  setError(true);
                  setPassword("");
                  setTimeout(() => setError(false), 500);
                }
              }}
            >
              Entrar
            </button>
          </div>
        </div>
      )}

      {/* Intro Pochacco */}
      {isUnlocked && showIntro && (
        <div
          className={`intro-screen ${introClosing ? "closing" : ""}`}
          onClick={handleIntroClick}
        >
          <img src="/logo-pochacco.png" alt="Pochacco logo" className="intro-logo" />
          <p className="intro-dedication">Para Francys</p>
          <p className="intro-dedication-2">(Sube el volumen)</p>
        </div>
      )}

      {/* Historia fase por fase */}
      {isUnlocked && !showIntro && !showProposal && phase !== null && (
        <div className="story-phase" onClick={handlePhaseClick}>
  {phases[phase].img && <img src={phases[phase].img} alt="" className="phase-img" />}
  <div className="phase-container">
    <p className="phase-text">{displayedText}</p>
    {!typing && phase !== 0 && <p className="next-indicator">▶</p>}
  </div>
</div>

      )}

      {/* Propuesta final */}
      {isUnlocked && showProposal && (
        <section className="proposal">
          <img src="/besito.png" alt="Pochacco besito" className="proposal-kiss" />
        </section>
      )}
    </>
  );
}

export default App;
